module.exports = __webpack_public_path__ + "static/img/qItem3-img7.53b56bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem3-img7.png
// module id = KriJ
// module chunks = 1